import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginService } from '../../services/login.service';

@Component({
    selector: 'lib-usuario-configuracao',
    templateUrl: './usuario-configuracao.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsuarioConfiguracaoComponent {
    constructor(public loginService: LoginService) { }
}
